import axiosInstance from "../../axios";
import config from "../../config";
import { usePersistedStore } from "../persisted-store";

export const createMarketerSlice = (set, get) => ({
    wages: {
        loading: false,
        companyDefaultWage: [],
        companyBranch: [],
        single: null
    },
    getCompanyDefaultAgentWage: async (companyBranchId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ wages: { ...state.wages, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: companyBranchId ? `/v1/business/get-company-default-agent-wage/CompanyBranchId/${companyBranchId}` : `/v1/business/get-company-default-agent-wage/CompanyBranchId`,
                headers: { token }
            });
            if (companyBranchId) {
                set(state => ({ wages: { ...state.wages, single: resp.data[0], loading: false } }));
            } else {
                set(state => ({ wages: { ...state.wages, companyDefaultWage: resp.data, loading: false } }));
            }
        } catch (error) {
            set(state => ({ wages: { ...state.wages, loading: false } }));
        }
    },
    getCompanyBranch: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ wages: { ...state.wages, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: '/v1/business/get-companybranchtree',
                headers: { token }
            });
            set(state => ({ wages: { ...state.wages, companyBranch: resp.data, loading: false } }));
        } catch (error) {
            set(state => ({ wages: { ...state.wages, loading: false } }));
        }
    },
    addCompanyDefaultAgentWage: async (param) => {
        const { params, cb, reset } = param;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ wages: { ...state.wages, loading: true } }));
        try {
            await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/add-company-default-agent-wage',
                data: params,
                headers: { token }
            });
            set(state => ({ wages: { ...state.wages, loading: false } }));
            get().getCompanyDefaultAgentWage();
            cb();
            reset();
        } catch (error) {
            set(state => ({ wages: { ...state.wages, loading: false } }));
        }
    },
    deleteCompanyDefaultWage: async (companyBranchId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ wages: { ...state.wages, loading: true } }));
        try {
            await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: `/v1/business/delete-company-default-agent-wage/companyBranchId/${companyBranchId}`,
                headers: { token }
            });
            set(state => ({ wages: { ...state.wages, loading: false } }));
            get().getCompanyDefaultAgentWage();
            // Notification logic would go here
        } catch (error) {
            set(state => ({ wages: { ...state.wages, loading: false } }));
        }
    },
    updateCompanyDefaultAgentWage: async (param) => {
        const { params, cb, reset } = param;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ wages: { ...state.wages, loading: true } }));
        try {
            await axiosInstance({
                method: 'post',
                baseURL: config.apiUrls(),
                url: '/v1/business/update-company-default-agent-wage',
                data: params,
                headers: { token }
            });
            get().getCompanyDefaultAgentWage();
            cb();
            reset();
        } catch (error) {
            set(state => ({ wages: { ...state.wages, loading: false } }));
        }
    }
});
